<template>
  <div id="login-bg">
    <div class="text-center pt-16 mt-16">
      <img class="mx-auto w-2/4" src="../assets/img/logo.png" />
      <h1 class="text-white text-xl font-bold mt-3">پخش مویرگی هلدینگ تبرک</h1>
    </div>
    <div class="w-full p-8">
      <h6
        class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500"
        v-if="loginError"
      >
        نام کاربری یا رمزعبور اشتباه است
      </h6>

      <form action="" @submit.prevent="login()">
        <VInput
          type="tel"
          class="w-full mt-2 text-white"
          placeholder="نام کاربری"
          v-model="user.UserName"
          required
        />
        <VInput
          type="password"
          class="w-full mt-2 text-white"
          placeholder="رمز عبور"
          v-model="user.Password"
          required
        />

        <button
          class="flex justify-center bg-bgbutton py-2 rounded-lg shadow-lg w-full mt-3 text-white"
          type="submit"
        >
          <LoadingSpinner class="w-6 ml-2 !text-gray-500" v-if="loading" />
          ورود
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import VInput from "../components/General/VInput.vue";
import LoadingSpinner from "../components/General/LoadingSpinner.vue";

export default {
  name: "LoginPage",
  components: { VInput, LoadingSpinner },
  data() {
    return {
      loading: false,
      user: {
        UserName: "",
        Password: "",
      },
      loginError: false,
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.$store
        .dispatch("login", this.user)
        .then(() => {
          this.$router.push("/customer");
          this.loginError = false;
        })
        .catch(() => {
          console.log("👉 Login failed");
          this.loginError = true;
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
#login-bg {
  content: "";
  background-color: #318053;
  @apply w-screen h-screen bg-no-repeat bg-cover overflow-hidden;
}
</style>
